var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoRecording({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 159,
    viewBox: "0 0 153 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V158.276H153V0H0ZM21.1034 147.724H10.5517V137.172H21.1034V147.724ZM21.1034 126.621H10.5517V116.069H21.1034V126.621ZM21.1034 105.517H10.5517V94.9655H21.1034V105.517ZM21.1034 84.4138H10.5517V73.8621H21.1034V84.4138ZM21.1034 63.3103H10.5517V52.7586H21.1034V63.3103ZM21.1034 42.2069H10.5517V31.6552H21.1034V42.2069ZM21.1034 21.1034H10.5517V10.5517H21.1034V21.1034ZM113.431 97.6035C113.431 103.431 108.707 108.155 102.879 108.155H50.1207C44.2935 108.155 39.569 103.431 39.569 97.6035V60.6724C39.569 54.8452 44.2935 50.1207 50.1207 50.1207H102.879C108.707 50.1207 113.431 54.8452 113.431 60.6724V97.6035ZM142.448 147.724H131.897V137.172H142.448V147.724ZM142.448 126.621H131.897V116.069H142.448V126.621ZM142.448 105.517H131.897V94.9655H142.448V105.517ZM142.448 84.4138H131.897V73.8621H142.448V84.4138ZM142.448 63.3103H131.897V52.7586H142.448V63.3103ZM142.448 42.2069H131.897V31.6552H142.448V42.2069ZM142.448 21.1034H131.897V10.5517H142.448V21.1034Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3105 92.3285V65.9492L92.3278 79.1389L63.3105 92.3285Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 76.5,
    y1: 0,
    x2: 76.5,
    y2: 158.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2CEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95B6EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 77.8192,
    y1: 65.9492,
    x2: 77.8192,
    y2: 92.3285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2CEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95B6EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecording);
export default __webpack_public_path__ + "static/media/no-recording.681e80956fefd43f41f35d20de908b18.svg";
export { ForwardRef as ReactComponent };